/*
 * BNZ RDV Sessions (sections/bnz-rdv-sessions.liquid)
 *
 * Toutes les sessions sont dans une seule grille, déjà triée par date côté Liquid.
 * Deux filtres se combinent :
 * - les pastilles région (« Toutes » par défaut, une seule active à la fois) ;
 * - le champ code postal / ville : un code postal est comparé au département
 *   noté entre parenthèses dans la ville (« CANNES (06) »), un texte au nom
 *   de la ville et du lieu, sans tenir compte des accents ni des majuscules.
 *
 * Rayon (data-radius, en km) : un code postal remonte aussi les sessions situées
 * à moins de ce rayon d'une commune du département tapé (Loire 42 : Lyon sort).
 * Les centres des communes viennent de l'API publique geo.api.gouv.fr : ceux du
 * département tapé, et celui de chaque session d'après « COMMUNE (dép.) ».
 * Le filtre par département s'applique tout de suite, le rayon complète la
 * liste dès que l'API a répondu. Si elle ne répond pas, on reste au département.
 *
 * - Ancre : /pages/...#paris-alentours arrive filtré sur la région.
 * - Éditeur de thème : sélectionner une région active sa pastille, sélectionner
 *   une session retire les filtres qui la masqueraient.
 * - Dates passées : le Liquid les masque déjà, mais la page peut sortir du cache
 *   Shopify avec un jour de retard. On refait donc le tri avec la date du jour.
 */
(function () {
  function todayInt() {
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  function normalize(text) {
    return (text || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function cardIndex(card) {
    if (card.bnzRdv) return card.bnzRdv;
    var cityEl = card.querySelector('[data-bnz-rdv-city]');
    var venueEl = card.querySelector('[data-bnz-rdv-venue]');
    var city = cityEl ? cityEl.textContent.trim() : '';
    var dept = city.match(/\((\d{2,5}|2[AB])\)/i);
    card.bnzRdv = {
      region: card.getAttribute('data-region') || '',
      dept: dept ? dept[1].toUpperCase() : '',
      commune: city.replace(/\(.*$/, '').trim(),
      text: normalize(city + ' ' + (venueEl ? venueEl.textContent : ''))
    };
    return card.bnzRdv;
  }

  /* ---------- Rayon autour du département ---------- */

  var GEO_API = 'https://geo.api.gouv.fr';
  var geoCache = {};

  function getJSON(url) {
    if (!geoCache[url]) {
      geoCache[url] = fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
        .catch(function (err) {
          delete geoCache[url];
          throw err;
        });
    }
    return geoCache[url];
  }

  // Département(s) d'un code postal : 2 chiffres, 3 en outre-mer, 2A / 2B en Corse.
  function deptCodes(digits) {
    if (digits.length < 2) return null;
    var two = digits.slice(0, 2);
    if (two === '20') {
      if (digits.length < 3) return ['2A', '2B'];
      return [Number(digits.slice(0, 3)) < 202 ? '2A' : '2B'];
    }
    if (two === '97' || two === '98') return digits.length < 3 ? null : [digits.slice(0, 3)];
    return [two];
  }

  function deptCentres(code) {
    return getJSON(GEO_API + '/departements/' + code + '/communes?fields=centre&format=json').then(function (list) {
      return list
        .map(function (c) { return c.centre && c.centre.coordinates; })
        .filter(Boolean);
    });
  }

  // Centre de la commune d'une session. Hors France (Genève…), pas de point : seul le texte compte.
  function cardPoint(info) {
    if (!info.commune || !/^(\d{2}|2[AB]|97\d)$/.test(info.dept)) return Promise.resolve(null);
    var url = GEO_API + '/communes?nom=' + encodeURIComponent(info.commune) +
      '&codeDepartement=' + info.dept + '&fields=centre&limit=1';
    return getJSON(url)
      .then(function (list) { return list[0] && list[0].centre ? list[0].centre.coordinates : null; })
      .catch(function () { return null; });
  }

  function km(a, b) {
    var rad = Math.PI / 180;
    var dLat = (b[1] - a[1]) * rad;
    var dLon = (b[0] - a[0]) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a[1] * rad) * Math.cos(b[1] * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 12742 * Math.asin(Math.sqrt(h));
  }

  function currentQuery(section) {
    var input = section.bnzRdvState.input;
    return input ? input.value.trim() : '';
  }

  function geoRefine(section) {
    var state = section.bnzRdvState;
    var query = currentQuery(section);
    var digits = query.replace(/\s+/g, '');
    var codes = /^\d+$/.test(digits) ? deptCodes(digits) : null;
    if (!codes || !state.radius) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bnz-rdv-card]'));
    Promise.all([
      Promise.all(codes.map(deptCentres)),
      Promise.all(cards.map(function (card) { return cardPoint(cardIndex(card)); }))
    ]).then(function (res) {
      if (currentQuery(section) !== query) return;
      var centres = [].concat.apply([], res[0]);
      var near = cards.filter(function (card, i) {
        var point = res[1][i];
        if (!point) return false;
        for (var j = 0; j < centres.length; j++) {
          if (km(point, centres[j]) <= state.radius) return true;
        }
        return false;
      });
      state.geo = { query: query, cards: near };
      apply(section);
    }).catch(function () {});
  }

  function matchesQuery(info, query) {
    if (!query) return true;
    var digits = query.replace(/\s+/g, '');
    if (/^\d+$/.test(digits)) {
      if (!info.dept) return false;
      // « 75011 » trouve le 75, « 7 » en cours de frappe trouve encore le 75.
      return digits.indexOf(info.dept) === 0 || info.dept.indexOf(digits) === 0;
    }
    return info.text.indexOf(normalize(query)) !== -1;
  }

  function apply(section) {
    var state = section.bnzRdvState;
    var query = currentQuery(section);
    var near = state.geo && state.geo.query === query ? state.geo.cards : null;
    var visible = 0;
    section.querySelectorAll('[data-bnz-rdv-card]').forEach(function (card) {
      var info = cardIndex(card);
      var inQuery = matchesQuery(info, query) || (near !== null && near.indexOf(card) !== -1);
      var show = (state.region === 'all' || info.region === state.region) && inQuery;
      card.hidden = !show;
      if (show) visible += 1;
    });
    var empty = section.querySelector('[data-bnz-rdv-empty]');
    if (empty) empty.hidden = visible > 0;
  }

  function setRegion(section, region) {
    var chips = section.querySelectorAll('[data-bnz-rdv-chip]');
    var found = false;
    chips.forEach(function (chip) {
      if (chip.getAttribute('data-bnz-rdv-chip') === region && !chip.hidden) found = true;
    });
    if (!found) region = 'all';
    section.bnzRdvState.region = region;
    chips.forEach(function (chip) {
      var active = chip.getAttribute('data-bnz-rdv-chip') === region;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    apply(section);
  }

  function prunePast(section) {
    if (section.hasAttribute('data-design-mode')) return;
    if (section.getAttribute('data-hide-past') !== 'true') return;
    var today = todayInt();
    var removed = false;
    section.querySelectorAll('[data-bnz-rdv-card]').forEach(function (card) {
      var d = Number(card.getAttribute('data-date')) || 0;
      if (d > 0 && d < today) {
        card.remove();
        removed = true;
      }
    });
    if (!removed) return;

    // Une région vidée par le passage à minuit perd sa pastille.
    var left = {};
    section.querySelectorAll('[data-bnz-rdv-card]').forEach(function (card) {
      left[card.getAttribute('data-region')] = true;
    });
    section.querySelectorAll('[data-bnz-rdv-chip]').forEach(function (chip) {
      var key = chip.getAttribute('data-bnz-rdv-chip');
      if (key !== 'all' && !left[key]) chip.hidden = true;
    });
  }

  function regionFromHash(section) {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    var chip = section.querySelector('[data-bnz-rdv-chip="' + id.replace(/"/g, '') + '"]');
    if (!chip || chip.hidden) return;
    setRegion(section, id);
    section.scrollIntoView({ block: 'start' });
  }

  function init(section) {
    if (!section || section.hasAttribute('data-bnz-rdv-ready')) return;
    section.setAttribute('data-bnz-rdv-ready', '');
    section.bnzRdvState = {
      region: 'all',
      input: section.querySelector('[data-bnz-rdv-search]'),
      radius: Number(section.getAttribute('data-radius')) || 0,
      geo: null
    };

    prunePast(section);

    section.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-bnz-rdv-chip]');
      if (chip && section.contains(chip)) setRegion(section, chip.getAttribute('data-bnz-rdv-chip'));
    });

    var input = section.bnzRdvState.input;
    if (input) {
      var timer = null;
      input.addEventListener('input', function () {
        apply(section);
        clearTimeout(timer);
        timer = setTimeout(function () { geoRefine(section); }, 250);
      });
      // Au premier clic dans le champ, on situe déjà les sessions : la réponse au code postal arrive plus vite.
      if (section.bnzRdvState.radius) {
        input.addEventListener('focus', function () {
          section.querySelectorAll('[data-bnz-rdv-card]').forEach(function (card) {
            cardPoint(cardIndex(card));
          });
        }, { once: true });
      }
    }

    apply(section);
    regionFromHash(section);
  }

  function initAll() {
    document.querySelectorAll('[data-bnz-rdv]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-bnz-rdv]').forEach(regionFromHash);
  });

  // Éditeur de thème
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-bnz-rdv]'));
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest('[data-bnz-rdv]');
    if (!section || !section.bnzRdvState) return;
    var chip = event.target.closest('[data-bnz-rdv-chip]');
    if (chip) {
      setRegion(section, chip.getAttribute('data-bnz-rdv-chip'));
      return;
    }
    if (event.target.closest('[data-bnz-rdv-card]') && event.target.hidden) {
      if (section.bnzRdvState.input) section.bnzRdvState.input.value = '';
      setRegion(section, 'all');
    }
  });
})();
